import React, { Component } from 'react'
import reportPaginateUtil, {
  ReportPaginateResponseData
} from '../utils/reportPaginate.util'
import shipApi, {
  ShippingReportExportRequest, ShippingReportPaginateRequest
} from '../apis/ship.api'
import downloadService from '../services/download.service'
import alertService from '../services/alert.service'
import { PaginateRequest } from '../services/api.service'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ShippingReportForm, {
  ShippingReportFormData
} from '../partials/ShippingReportForm'
import Card from '../components/Card'
import DataTable, { DataTableData } from '../components/DataTable'
import { TableHorizontalHeader } from '../components/TableHorizontal'

interface Props {}

interface State
  extends DataTableData<ReportPaginateResponseData>, PaginateRequest {
    formData: ShippingReportFormData | null
  }

export default class ShippingReport extends Component<Props, State> {
  get headers (): TableHorizontalHeader[] {
    return reportPaginateUtil.headers(this.state.data)
  }

  constructor (props: Props) {
    super(props)
    this.state = {
      formData: null,
      data: [],
      total: 0,
      from: null,
      to: null,
      currentPage: 0,
      lastPage: 0,
      page: 1,
      limit: 25,
      search: ''
    }
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
    this.handleSearchClick = this.handleSearchClick.bind(this)
    this.handleExportClick = this.handleExportClick.bind(this)
  }

  get reportPaginate () {
    return this.state.formData &&
      <Card className="mt-5">
        <DataTable
          headers={this.headers}
          data={this.state.data}
          total={this.state.total}
          from={this.state.from}
          to={this.state.to}
          currentPage={this.state.currentPage}
          lastPage={this.state.lastPage}
          limit=""
          search=""
          onLimtChange={this.handleLimitChange}
          onSearch={this.handleSearch}
          onPaginate={this.handlePaginate} />
      </Card>
  }

  handleLimitChange (limit: string) {
    this.setState({ limit: Number(limit) }, this.paginate)
  }

  handleSearch (search: string) {
    this.setState({ search }, this.paginate)
  }

  handlePaginate (page: number) {
    this.setState({ page }, this.paginate)
  }

  exportShips (data: ShippingReportFormData) {
    const { fromDate, toDate, itemId, customerId, lpn } = data
    const payload: ShippingReportExportRequest = {}
    if (fromDate) payload.startAt = fromDate
    if (toDate) payload.endAt = toDate
    if (itemId) payload.item = itemId
    if (customerId) payload.customer = customerId
    if (lpn) payload.lpn = lpn
    shipApi.exportReport(payload, ships => {
      if (!ships) {
        alertService.info('No results to export')
        return
      }
      downloadService.download(ships, 'shippingReport.csv')
    })
  }

  paginate () {
    const { formData } = this.state
    if (!formData) return
    const { fromDate, toDate, itemId } = formData
    const { page, limit, search } = this.state
    const payload: ShippingReportPaginateRequest = { page, limit, search }
    if (fromDate) payload.startAt = fromDate
    if (toDate) payload.endAt = toDate
    if (itemId) payload.item = itemId
    shipApi.paginateReport(payload, paginate => {
      if (!paginate) return
      const { total, from, to, currentPage, lastPage } = paginate
      this.setState({ total, from, to, currentPage, lastPage })
      this.setState({ data: reportPaginateUtil.data(paginate.data) })
    })
  }

  handleSearchClick (formData: ShippingReportFormData) {
    this.setState({ formData }, () => this.paginate())
  }

  handleExportClick (data: ShippingReportFormData) {
    this.exportShips(data)
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <ShippingReportForm
            onSearchClick={this.handleSearchClick}
            onExportClick={this.handleExportClick} />
          {this.reportPaginate}
        </ContentMain>
      </ContentLayout>
    )
  }
}
